import { makeActionCreator } from '../../../../utilities'
import { AirwayConstants } from './airway.constants'

export const setAction = makeActionCreator(AirwayConstants.SET_ACTION, 'action')
export const setFlow = makeActionCreator(AirwayConstants.SET_FLOW, 'flow')
export const setFiO2 = makeActionCreator(AirwayConstants.SET_FIO2, 'fiO2')
export const setVia = makeActionCreator(AirwayConstants.SET_VIA, 'via')
export const setHumidity = makeActionCreator(AirwayConstants.SET_HUMIDITY, 'humidity')
export const setOralPharyngealAirway = makeActionCreator(
  AirwayConstants.SET_ORAL_PHARYNGEAL_AIRWAY,
  'oralPharyngealAirway'
)
export const setAirTemperature = makeActionCreator(AirwayConstants.SET_AIR_TEMPERATURE, 'airTemperature')
export const setAirTemperatureUnit = makeActionCreator(AirwayConstants.SET_AIR_TEMPERATURE_UNIT, 'airTemperatureBool')
export const setAirTemperatureUnitTemp = makeActionCreator(
  AirwayConstants.SET_AIR_TEMPERATURE_UNIT_TEMP,
  'airTemperatureUnit'
)
export const setAirwayComplications = makeActionCreator(AirwayConstants.SET_AIRWAY_COMPLICATIONS, 'airwayComplications')
export const setAirwayComplicationsPNNV = makeActionCreator(
  AirwayConstants.SET_AIRWAY_COMPLICATIONS_PNNV,
  'airwayComplicationsPNNV'
)
export const setVerificationMethod = makeActionCreator(AirwayConstants.SET_VERIFICATION_METHOD, 'verificationMethod')
export const setPressure = makeActionCreator(AirwayConstants.SET_PRESSURE, 'pressure')
export const setInspiratoryPressure = makeActionCreator(AirwayConstants.SET_INSPIRATORY_PRESSURE, 'inspiratoryPressure')
export const setExpiratoryPressure = makeActionCreator(AirwayConstants.SET_EXPIRATORY_PRESSURE, 'expiratoryPressure')
export const saveAirway = makeActionCreator(AirwayConstants.SAVE_AIRWAY, 'data')
export const resetState = makeActionCreator(AirwayConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(AirwayConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(AirwayConstants.SET_STATE, 'airwayState')
export const setDateTime = makeActionCreator(AirwayConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(AirwayConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectAirwayProcedure = makeActionCreator(AirwayConstants.ON_SELECT_AIRWAY)
export const setUpdateInputRows = makeActionCreator(AirwayConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSuccessfulAttempt = makeActionCreator(AirwayConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(AirwayConstants.SET_ATTEMPTS, 'attempts')
export const setSize = makeActionCreator(AirwayConstants.SET_SIZE, 'size')
export const setRolePerforming = makeActionCreator(AirwayConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setAirwayDefaults = makeActionCreator(AirwayConstants.SET_AIRWAY_DEFAULTS, 'airwayDefaults')
export const setReasonsForFailure = makeActionCreator(AirwayConstants.SET_REASONS_FOR_FAILURE, 'reasonsForFailure')

export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  AirwayConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  AirwayConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
